var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14.2002,
    r: 13.5,
    stroke: "#D4D4D8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_643_455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.04 14.3672C21.04 13.8472 20.9933 13.3472 20.9067 12.8672H14V15.7039H17.9467C17.7767 16.6205 17.26 17.3972 16.4833 17.9172V19.7572H18.8533C20.24 18.4805 21.04 16.6005 21.04 14.3672V14.3672Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9986 21.5338C15.9786 21.5338 17.6386 20.8771 18.852 19.7571L16.482 17.9171C15.8253 18.3571 14.9853 18.6171 13.9986 18.6171C12.0886 18.6171 10.472 17.3271 9.89531 15.5938H7.44531V17.4938C8.65198 19.8904 11.132 21.5338 13.9986 21.5338Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89797 15.5939C9.7513 15.1539 9.66797 14.6839 9.66797 14.2006C9.66797 13.7172 9.7513 13.2472 9.89797 12.8072V10.9072H7.44797C6.93464 11.9291 6.66752 13.057 6.66797 14.2006C6.66797 15.3839 6.9513 16.5039 7.44797 17.4939L9.89797 15.5939V15.5939Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9986 9.78385C15.0753 9.78385 16.042 10.1539 16.802 10.8805L18.9053 8.77719C17.6353 7.59385 15.9753 6.86719 13.9986 6.86719C11.132 6.86719 8.65198 8.51052 7.44531 10.9072L9.89531 12.8072C10.472 11.0739 12.0886 9.78385 13.9986 9.78385Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_643_455"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6.2002,
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.4416c3bbca7858a6c7071cde7bf6a901.svg";
export { ForwardRef as ReactComponent };